import React from 'react';
import ProfileTemplate from '../ProfileTemplate';
import ApiKeyList from './ApiKeyList';
import Wallet from './Wallet';

import './Status.scss';

export default function Status() {
  return <ProfileTemplate className="status">
    {/* <Alert>
      <strong>ATT!</strong> The Email and Ethereum Address Must Match the One Previously Provided by our KYC Process.
    </Alert> */}

    <div className="border-bottom pb-4 row">
      <div className="col-md-6 mt-4">
        <Wallet />
      </div>

      <div className="col-md-6 mt-4 pt-2 pt-sm-0">
        <ApiKeyList />
      </div>

    </div>
  </ProfileTemplate>;
}